/** Live USD→TTD mid-market. Never use generation USD_TO_TTD = 10 here. */

const FX_URLS = [
  "https://open.er-api.com/v6/latest/USD",
  "https://api.exchangerate.host/latest?base=USD&symbols=TTD",
];

function parseTtdPerUsd(payload: unknown): number | null {
  if (!payload || typeof payload !== "object") return null;
  const row = payload as {
    rates?: { TTD?: number };
    conversion_rates?: { TTD?: number };
  };
  const rate = Number(row.conversion_rates?.TTD ?? row.rates?.TTD);
  if (!Number.isFinite(rate) || rate < 1 || rate > 50) return null;
  return rate;
}

/** Single config value: checkout display and every server charge use 1 US$ = 7 TT$. */
export const FIXED_USD_TO_TTD = 7;

/** Fixed rate (Dallas, 2026-10-15). Kept async so callers stay unchanged. */
export async function fetchLiveUsdToTtd(): Promise<number> {
  return FIXED_USD_TO_TTD;
}

export async function fetchMarketUsdToTtd(): Promise<number> {
  let lastError = "Live FX rate is unavailable. Try again.";
  for (const url of FX_URLS) {
    try {
      const res = await fetch(url, { cache: "no-store" });
      if (!res.ok) {
        lastError = `FX ${res.status}`;
        continue;
      }
      const rate = parseTtdPerUsd(await res.json());
      if (rate) return rate;
    } catch (err) {
      lastError = err instanceof Error ? err.message : lastError;
    }
  }
  throw new Error(lastError);
}

export function formatUsdFromCents(usdCents: number): string {
  return (usdCents / 100).toFixed(2);
}
